import { useContext } from 'react';

import { ConfigContext } from './config-provider';

export function useConfig() {
  const configContext = useContext(ConfigContext);

  if (!configContext) {
    throw new Error('useConfig must be used within a ConfigProvider');
  }

  return configContext.config;
}
